import React, { useEffect, useState, useRef } from "react";
import Modal from "@/app/core/layouts/main/components/Modal";
import { ComplainController } from "@/app/core/base/controllers/ComplainController";
import { CnpjMask, OnDataChange } from "@/app/core/util/helpers/FieldHelper";
import { TimelineController } from "@/app/core/base/controllers/TimelineController";
import Storage from "@/app/core/util/Storage";
import CompanySearch from "../input/CompanySearch";

export default function SelectCompanyModal({ show, onHide, infos, report }) {
    const [data, setData] = useState({});
    const [userData, setUserData] = useState(Storage.getUserData());


    useEffect(() => {
        console.log("informações", infos)
        if (show && infos && infos.id) {
            setData(infos);
        } else {
            setData({});
        }
    }, [show]);

    async function loadInfos() {
    }

    async function save(company) {
        TimelineController.Insert({
            description: `${userData.name} trocou a empresa da reclamação para ${company?.name}`,
            complainId: data.id,
        });

        report(company)

        onHide();
    }


    function handleChange(evt, type) {
        setData(OnDataChange(data, evt, type))
    }

    function selectCompany(company){
        save(company)
    }

    return (
        <Modal
            title={`Selecionar Empresa`}
            show={show}
            onHide={onHide}
            isLoading={false}
            onSubmit={() => save()}
        >

            <CompanySearch onFullSelection={item => selectCompany(item)}/>
            
        </Modal>
    );
}
